var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64557 5.11996H7.08801C7.33528 5.09033 7.52172 4.8755 7.52172 4.6202C7.52172 4.36491 7.33528 4.15007 7.08801 4.12045H2.64557C2.45789 4.09796 2.27429 4.18799 2.17354 4.35192C2.07278 4.51586 2.07278 4.72455 2.17354 4.88848C2.27429 5.05241 2.45789 5.14245 2.64557 5.11996Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64557 10.5595H5.81495C6.00263 10.582 6.18623 10.4919 6.28698 10.328C6.38774 10.1641 6.38774 9.95539 6.28698 9.79146C6.18623 9.62753 6.00263 9.53749 5.81495 9.55998H2.64557C2.45789 9.53749 2.27429 9.62753 2.17354 9.79146C2.07278 9.95539 2.07278 10.1641 2.17354 10.328C2.27429 10.4919 2.45789 10.582 2.64557 10.5595Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35443 7.83973H2.64557C2.45789 7.86222 2.27429 7.77218 2.17354 7.60825C2.07278 7.44432 2.07278 7.23562 2.17354 7.07169C2.27429 6.90776 2.45789 6.81773 2.64557 6.84021H8.35443C8.6017 6.86984 8.78815 7.08467 8.78815 7.33997C8.78815 7.59527 8.6017 7.8101 8.35443 7.83973Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81736 14H3.17601C1.42088 13.9963 -3.80888e-06 12.5361 0 10.7363V3.25692C0.00364736 1.45972 1.42346 0.00374027 3.17601 0H7.81736C9.5725 -3.90591e-06 10.9963 1.45707 11 3.25692V10.7363C11 11.6019 10.6647 12.432 10.0678 13.0441C9.47096 13.6561 8.66145 14 7.81736 14ZM3.17601 1.08111C2.0057 1.08484 1.05789 2.0568 1.05425 3.25692V10.7363C1.05424 11.9391 2.00312 12.9151 3.17601 12.9189H7.81736C8.99283 12.9189 9.94575 11.9417 9.94575 10.7363V3.25692C9.94209 2.05415 8.99025 1.0811 7.81736 1.08111H3.17601Z",
    fill: "#9A9A9A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocicon);
export default __webpack_public_path__ + "static/media/docicon.40805319050b6ef9a99a92f7cf250711.svg";
export { ForwardRef as ReactComponent };